export default __webpack_public_path__ + "static/media/gallery_04.8f934d23.jpg";